export const borderColor = 'rgb(210, 218, 226)';  // was rgb(240,240,240) — visible divider lines